<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <app-skeleton-rect width="180px" height="18px"></app-skeleton-rect>
  </div>
  <div class="card-content">
    <div class="card-body">
      <div class="d-flex">
        <div class="flex-fill me-2">
          <app-skeleton-rect width="100%" height="350px" [borderRadius]="'8px'"></app-skeleton-rect>
        </div>
        <div style="width: 140px;">
          <ng-container *ngFor="let _ of [0,1,2,3,4,5,6,7,8,9,10,11]">
            <div class="d-flex align-items-center mb-2">
              <app-skeleton-rect width="12px" height="12px" [borderRadius]="'50%'" class="me-2"></app-skeleton-rect>
              <app-skeleton-rect width="110px" height="12px"></app-skeleton-rect>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
